import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          data-testid="back-to-top-btn"
          aria-label="Retour en haut de page"
          onClick={() => window.__lenis?.scrollTo(0)}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="group fixed bottom-6 right-6 z-50 flex h-12 items-center justify-center gap-2.5 border border-[#C8A97E]/60 bg-[#0B2215]/90 px-5 backdrop-blur-sm transition-colors duration-300 hover:bg-[#C8A97E] md:bottom-8 md:right-8"
        >
          <ArrowUp className="h-4 w-4 text-[#C8A97E] transition-colors duration-300 group-hover:text-[#0B2215]" />
          <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-[#C8A97E] transition-colors duration-300 group-hover:text-[#0B2215]">
            Retour en haut
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};
